export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    slug: 'yulequan',
    name: '娱乐圈',
    icon: 'ri-movie-2-line',
    description: '影视圈、综艺圈的各类爆料与内幕',
  },
  {
    slug: 'wanghong',
    name: '网红',
    icon: 'ri-live-line',
    description: '短视频平台网红、主播相关黑料',
  },
  {
    slug: 'mingxing',
    name: '明星',
    icon: 'ri-star-line',
    description: '当红明星、偶像艺人的八卦爆料',
  },
  {
    slug: 'dianjing',
    name: '电竞圈',
    icon: 'ri-gamepad-line',
    description: '电竞选手、游戏主播的争议事件',
  },
  {
    slug: 'shehui',
    name: '社会热点',
    icon: 'ri-fire-line',
    description: '社会民生相关的热门争议话题',
  },
];